import { onDocumentReady } from "./utils/document-ready";
import { lazyLoadComponent, lazyLoadComponentOnce } from "./utils/loader";

onDocumentReady(() => {
  lazyLoadComponentOnce(() => import("./components/nav-menu"), ".js--nav-menu");

  lazyLoadComponentOnce(() => import("./components/nav-subnav"), ".js--subnav");

  lazyLoadComponentOnce(
    () => import("./components/nav-sticky"),
    ".js--nav-sticky",
  );

  lazyLoadComponent(() => import("./components/nav-jump"), ".js--nav-jump");

  lazyLoadComponent(
    () => import("./components/marquee-text"),
    ".js--marquee-text",
  );

  lazyLoadComponent(
    () => import("./components/ambient-video"),
    ".js--ambient-video",
  );

  if (document.querySelector(".js-nav-search-toggle")) {
    import("./components/nav-search.js").then(({ initNavSearch }) =>
      initNavSearch(),
    );
  }

  if (document.querySelector(".js-search-input")) {
    import("./components/search.js").then(({ initSearch }) => initSearch());
  }

  const listingEl = document.querySelector(".js--listing");
  if (listingEl) {
    import("./components/listing.js").then(
      ({ Listing }) => new Listing(listingEl),
    );
  }

//   lazyLoadComponent(
//     () => import("./components/tabbed-table"),
//     ".js--tabbed-table",
//   );
// 
//   lazyLoadComponent(
//     () => import("./components/carousels/carousel"),
//     ".js--carousel",
//   );
//   lazyLoadComponent(
//     () => import("./components/carousels/carousel-mobile-only"),
//     ".js--carousel-mobile",
//   );
//   lazyLoadComponent(
//     () => import("./components/carousels/spotlight-carousel"),
//     ".js--spotlight-carousel",
//   );
});
